import React from "react";
import { Link } from "react-router-dom";
import logo from "assets/logo-f.png";
import { useTranslation } from "react-i18next";

const Logo = () => {
  const { t } = useTranslation();

  return (
    <Link to="/">
      <img
        className="w-32 sm:w-40 md:w-44 xl:w-1/2 mx-auto"
        src={logo}
        alt={t("common.logo")}
      />
    </Link>
  );
};

export default Logo;
